import React from 'react';
import PaginationButton from './PaginationButton';
import PaginationIcon from './PaginationIcon';
import PaginationWrapper from './PaginationWrapper';
import Filler from './PaginationFiller';

const generateKey = pre => `${pre}_${new Date().getTime()}`;

const Pagination = ({ currentPage, pageCount, displayLimit, handleSetPage }) => {
    const isLast = currentPage === pageCount;
    const isActive = page => page === currentPage;

    // Ensure we have at least one page to show. One number and two fillers.
    const displayPages = Math.max(1, displayLimit);

    // Don't brake the app, but log the error.
    if (currentPage > pageCount) {
        console.error('Current page number exceeds total pages.');
        return <div className='stolo-hidden' >PAGINATION BROKEN</div >;
    }


    const handleNext = () => {
        console.info('Current page %s.', currentPage);
        handleSetPage(currentPage + 1);
    }
    const handlePrev = () => handleSetPage(currentPage - 1);



    let displayAll = false;
    let displayFirstFiller = false;
    let displayLastFiller = false;
    let min;
    let max;

    if (pageCount <= displayPages) {
        displayAll = true;
        min = 2;
        max = pageCount - 1;
    }

    if (pageCount > displayPages) {
        const remaining = pageCount - currentPage;

        min = currentPage - Math.floor(displayPages * 0.5);
        max = currentPage + Math.floor(displayPages * 0.5) || pageCount - 1;

        // We start at a minimum from 2. Put any difference in containters (displayPages) to the right side.
        if (min <= 2) {
            max = Math.max(max + min, displayPages);
            min = 2;
        }

        // We stop at totalPages -1. Put any remaining to the left.
        if (max > pageCount - 1) {
            min = Math.min(min - remaining, (min - max) + pageCount + 1);
            max = pageCount - 1;
        }

        displayFirstFiller = remaining === 0 || min > 2;
        displayLastFiller = max < pageCount - 1;
    }


    const buildItems = () => {
        const items = [];

        items[0] = (<PaginationIcon
            direction='left'
            disabled={isActive(1)}
            handleClick={handlePrev}
            key={generateKey('left')}
        />);

        items[1] =
            (<PaginationButton
                pageNumber={1} handleClick={() => handleSetPage(1)}
                key={generateKey('first')} disabled={isActive(1)}
            />);

        if (pageCount > 1) {
            if (pageCount > 2) {
                if (!displayAll && displayFirstFiller) {
                    items.push(<Filler key={generateKey('filler1')} />);
                }
                for (let i = min; i <= max; i++) {
                    items.push(
                        <PaginationButton
                            pageNumber={i}
                            handleClick={() => handleSetPage(i)}
                            key={generateKey(i)}
                            disabled={isActive(i)}
                        />,
                    );
                }
                if (!displayAll && displayLastFiller) {
                    items.push(<Filler key={generateKey('filler2')} />);
                }
            }

            items.push(<PaginationButton
                pageNumber={pageCount}
                handleClick={() => handleSetPage(pageCount)}
                key={generateKey('last')}
                disabled={isLast}
            />);
        }

        items.push(
            <PaginationIcon
                direction='right'
                disabled={isLast}
                handleClick={handleNext}
                key={generateKey('right')}
            />,
        );

        return items;
    };

    return (
        <PaginationWrapper key={generateKey('pager')} items={buildItems()} />
    );
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/Pagination.js